import { render, staticRenderFns } from "./GlobalSearchToggle.vue?vue&type=template&id=7fa238af"
import script from "./GlobalSearchToggle.vue?vue&type=script&lang=js"
export * from "./GlobalSearchToggle.vue?vue&type=script&lang=js"
import style0 from "./GlobalSearchToggle.vue?vue&type=style&index=0&id=7fa238af&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports